import type { RouteRecordRaw } from 'vue-router'

import { keys } from '@/app/i18n'

import type { DashboardPage } from './api/types'

/**
 * The four dashboards (wp/dashboards §3, manifest rows of WP-18): the legacy paths and names, unchanged (D-15) — the
 * home rule, the software switcher and the error pages build `/<software>/dashboard` by string. They replace the
 * shell's "Not migrated yet" placeholders by existing. `/ac/dashboard` (legacy: a redirect to `/ac/finances`) is the
 * finances module's widget board since 2026-10-26, `/hr/dashboard` and `/re/dashboard` widget boards too since
 * 2026-11-03; `/dashboard/analytics` is dropped (FD-014, D-16). `/on/dashboard` and `/en/dashboard` redirect to
 * `/hr/dashboard`, which holds their cards (BR-097, 2026-11-03; the shell's redirect).
 *
 * No `resource` (legacy had none; the API gates each block). `meta.software` lets the guard (D-21) send a user who
 * types another user type's dashboard — a Freelancer on `/re/dashboard`, a Client on `/ca/dashboard` — to the
 * not-authorized page (OPEN-4); any other refusal shows the dashboard's error state (NEW-11).
 */
function dashboard(software: DashboardPage, name: string, view: () => Promise<unknown>): RouteRecordRaw {
  return {
    path: `/${software}/dashboard`,
    name,
    component: view,
    // The HR and Recruitment boards greet instead of a breadcrumb row, as the Accounting one (2026-11-03): no crumb, no
    // page title.
    meta:
      software === 'hr' || software === 're'
        ? { software }
        : {
            software,
            pageTitle: keys.t('common.nav.dashboard'),
            breadcrumb: [{ text: keys.t('common.nav.dashboard'), active: true }],
          },
  }
}

const routes: RouteRecordRaw[] = [
  dashboard('re', 're_dashboard', () => import('./views/ReDashboardView.vue')),
  dashboard('hr', 'hr_dashboard', () => import('./views/HrDashboardView.vue')),
  dashboard('ca', 'ca-dashboard', () => import('./views/CaDashboardView.vue')),
  dashboard('em', 'em-dashboard', () => import('./views/EmDashboardView.vue')),
]

export default routes
